import React from "react";
import { PatientSummary } from "../../../types";
import CardsViewShell from "../../../components/views/cards-view-shell";
import PatientCard from "./patient-card";

interface PatientsCardsViewProps {
  filteredPatients: PatientSummary[];
  unfilteredPatientsCount: number;
}

const PatientsCardsView: React.FC<PatientsCardsViewProps> = ({
  filteredPatients,
  unfilteredPatientsCount,
}) => {
  return (
    <CardsViewShell shownCount={filteredPatients.length} totalCount={unfilteredPatientsCount}>
      {filteredPatients.map((patient) => {
        return <PatientCard key={patient.patientId} patient={patient} />;
      })}
    </CardsViewShell>
  );
};

export default PatientsCardsView;
